import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { AplicacionService } from '../../Aplicaciones/shared/aplicacion.service';
import { officeAplicacionService } from '../../officeAplicacion/shared/officeAplicacion.service'
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { Aplicacion, Iapplication } from '../../Aplicaciones/shared/aplicacion.model';
import { officeAplicacion, IofficeAplicacion } from '../../officeAplicacion/shared/officeAplicacion.model';
import { Office } from '../../office/shared/office.model';


@Component({
  selector: 'app-officeAplicacion',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'officeAplicacion.component.html',
})

export class officeAplicacionListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  @Input() ID: number;


  // dataSource = ELEMENT_DATA;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[] = ['indCheck', 'OfficeID', 'OfficeName', 'AplicacionID', 'Name', 'Descripcion', 'Status'];
  dataSource: GridDataSource; //MatTableDataSource<Iaplicacion>;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;
  officeIDSelected: number;
  offices: Office[];
  officeAplicacion: IofficeAplicacion;

  constructor(private loaderService: LoaderService, private aplicacionService: AplicacionService,
    private errorService: ErrorService, private notificationService: NotificationService,
    private officeAplicacionService: officeAplicacionService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.titlePage = 'Aplicacion';
    this.msgErrorGet = 'Error al listar las Oficinas / aplicacion';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
    this.listOffice();
    this.buscarAplicacion("");
  }

  handleRowClick(row: any, event: any, rowNum: number) {
    this.selectedRowIndex = row.rownum;
    this.data.aplicacion = { codVersion: row.codVersion };
    this.changeEvent({ evento: EVENTO.consultar, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarAplicacion(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarAplicacion(this.sectionBarComponent.filtro);
  }

  buscarAplicacion(filtro: string) {
    this.clearMatPaginator();
    this.listarAplicacion(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }
  private listOffice() {
    this.loaderService.show();
    this.officeAplicacionService.listOfficesAll().subscribe(res => {
      this.offices = res
    })

  }
  private listarAplicacion(filtro: string): void {
    this.loaderService.show();
    this.aplicacionService.listarAccessApplicacton(filtro, 0, this.pageEvent.pageIndex, this.pageEvent.pageSize)
      .subscribe(res => {
        if (this.errorService.getMessageError(res)) {
          this.dataSource = new GridDataSource(res); //new GridDataSource(res);
          this.showHideMessageGridEmpty(Number(res.length));
          this.pageEvent.length = res.length;
          //this.dataSource = new GridDataSource(res.Data.Items);
          //this.showHideMessageGridEmpty(Number(res.Data.Items.length));
          //this.pageEvent.length = res.Data.TotalCount;
          this.setMatPaginator();
        }
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  onChangeVinculacion(event: any, row: any) {
    let OfficeID: number;
    if (event.checked)
      OfficeID = 1;
    else
      OfficeID = row.OfficeID;

    this.toggleOfficeAplicacion(OfficeID, row.ID, event.checked)
  }

  private toggleOfficeAplicacion(OfficeID: number, AplicacionID: number, pToggle: boolean): void {
    this.loaderService.show();
    this.officeAplicacionService.toggleOfficeAcplicaion(OfficeID, AplicacionID, pToggle)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          // this.notificationService.showMessage(this.msgErrorToggleVincularCorreoAfiliado, TYPEMESSAGE.Error);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  public onChangeOficce(event: any) {
  }



}

